<div class="container p-2" *transloco="let t">
  <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2 mb-4">
    <div>
      <p class="text-muted mb-0">{{ currentStepLabel() }}</p>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        class="btn"
        [class.btn-outline-secondary]="!showAvailableTranslations()"
        [class.btn-secondary]="showAvailableTranslations()"
        type="button"
        (click)="onToggleAvailableTranslations()"
      >
        {{ showAvailableTranslations() ? 'Hide translations' : 'Show translations' }}
      </button>
      <button
        class="btn btn-outline-primary"
        type="button"
        (click)="onToggleAllInsightBodies()"
        [disabled]="seedLoading() || loading() || !insights().length"
      >
        {{ allInsightBodiesExpanded() ? 'Collapse all' : 'Expand all' }}
      </button>
      <button class="btn btn-primary" type="button" (click)="goToNextView()" [disabled]="seedLoading() || loading()">
        {{ t('common.next') }}
      </button>
    </div>
  </div>

  @if (seedLoading()) {
    <div class="alert alert-info mb-3">{{ t('common.loading') }}</div>
  }

  @if (!seedLoading()) {
    <form class="card card-body mb-4" [formGroup]="form" (ngSubmit)="onApplyQueryParams()">
      <div class="row g-3">
        <div class="col-12 col-lg-3">
          <label class="form-label" for="culture-select">{{ t('common.culture') }}</label>
          <select id="culture-select" class="form-select" formControlName="culture">
            @for (culture of cultures(); track culture.id) {
              <option [value]="culture.slug">{{ culture.name }}</option>
            }
          </select>
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label" for="difference-select">{{ t('content.insights') }} / Difference</label>
          <select id="difference-select" class="form-select" formControlName="difference">
            <option value="">None (use exclude list)</option>
            @for (difference of differences(); track difference.id) {
              <option [value]="difference.slug">{{ difference.name }}</option>
            }
          </select>
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label" for="category-select">category</label>
          <select id="category-select" class="form-select" formControlName="category" multiple>
            <option value="__ANY__">Any (omit filter)</option>
            <option value="__NONE__">None (empty filter)</option>
            @for (option of categoryOptions; track option.label) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label" for="type-select">type</label>
          <select id="type-select" class="form-select" formControlName="type" multiple>
            <option value="__ANY__">Any (omit filter)</option>
            <option value="__NONE__">None (empty filter)</option>
            @for (option of typeOptions; track option.label) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label" for="exclude-differences-input">excludeDifferences (CSV)</label>
          <input id="exclude-differences-input" class="form-control" type="text" formControlName="excludeDifferences" placeholder="rules,space,judging" />
        </div>

        <div class="col-6 col-lg-1">
          <label class="form-label" for="per-page-input">perPage</label>
          <input id="per-page-input" class="form-control" type="number" min="1" max="100" formControlName="perPage" />
        </div>

        <div class="col-6 col-lg-1">
          <label class="form-label" for="page-input">page</label>
          <input id="page-input" class="form-control" type="number" min="1" formControlName="page" />
        </div>

        <div class="col-12 col-lg-2 d-flex align-items-end">
          <button class="btn btn-outline-primary w-100" type="submit">{{ t('common.apply_filters') }}</button>
        </div>
      </div>
    </form>
  }

  @if (error()) {
    <div class="alert alert-danger mb-3">{{ t(error()) }}</div>
  }

  @if (loading()) {
    <div class="alert alert-secondary mb-3">{{ t('common.loading') }}</div>
  }

  @if (resultMeta()) {
    <div class="small text-muted mb-3">
      Total: {{ resultMeta()?.total || 0 }}
      <span class="mx-2">|</span>
      Page: {{ resultMeta()?.current_page || 1 }} / {{ resultMeta()?.last_page || 1 }}
    </div>
  }

  @if (!loading() && insights().length === 0) {
    <div class="alert alert-warning">{{ t('common.no_results') }}</div>
  }

  <div class="d-flex flex-column gap-3">
    @for (insight of insights(); track insight.id) {
      <div class="d-flex flex-column gap-2">
        <multisite-insights-viewer-card
          [insight]="insight"
          [isBodyExpanded]="isInsightBodyExpanded(insight.id)"
          (bodyExpandedToggle)="onInsightBodyExpandedToggle(insight.id, $event)"
          [showId]="true"
          [showSlug]="true"
          [showCategory]="true"
          [showType]="true"
          [showCultures]="true"
          [showDifferences]="true"
          [showTopics]="true"
          [showAvailableTranslations]="showAvailableTranslations()"
          [showSendForTranslation]="showAvailableTranslations()"
          (sendForTranslationRequest)="onSendForTranslationRequest(insight.id)"
        ></multisite-insights-viewer-card>

        @if (openTranslationPanelInsightId() === insight.id) {
          <multisite-insight-translation
            [insight]="insight"
            (closeRequest)="onTranslationPanelClosed()"
            (committed)="onTranslationCommitted()"
          ></multisite-insight-translation>
        }
      </div>
    }
  </div>
</div>
